// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1484":"f3031e6b","4027":"4c99acb5","6366":"422fe3fb","8060":"8e9ac1cf","9487":"4c99acb5"}[chunkId] + ".chunk.css";
};